import React from "react";
import { MainHeader, PageLayout } from "shared";
import { PrivacyAndPolicy } from ".";

export const Privacy = () => {
  return (
    <>
      <MainHeader />
      <PageLayout breadcrumb={[{ label: "Privacy Policy" }]}>
        <PrivacyAndPolicy />
      </PageLayout>
    </>
  );
};
